﻿import { required, alpha, email, maxLength, numeric, minLength } from 'vuelidate/lib/validators';
import checkoutService from '../api/checkout';
import { mapGetters, mapState } from 'vuex';

const nameCheck = value => {
    if (typeof value === 'undefined' || value === null || value === '') {
        return true;
    }
    return /^[^0-9<>(){}\[\]/\\|½@$£€§#%+=*?!&.,]{2,}$/.test(value);
    }

export default {
name: 'sales-lead-module',
    data: () => ({
        leadInformationSent: false,
        response: '',
        model: {
            name: "",
            email: "",
            phoneNumber: ""
        },
    }),
    props: ['viewmodel'],
    mounted() {
        this.model = this.viewmodel;
    },
    validations: {
        model: {
            name: {
                required,
                nameCheck,
                minLength: minLength(2),
                maxLength: maxLength(63)
            },
            email: {
                required,
                maxLength: maxLength(53),
				email
            },		
            phoneNumber: {
                required,
                numeric,
                minLength: minLength(8),
                maxLength: maxLength(8)
            }
        }
    },
    computed:
        Object.assign(
            mapState({
                address: state => state.offeringpage.addresslookup.query,
                hasLookupFailure: state => state.offeringpage.addresslookup.failure
            })
    ),
    methods: {
        sendLeadInformation() {
            const parameters = { 
                name: this.model.name,
                email: this.model.email,
                phoneNumber: this.model.phoneNumber,
                blockId: this.viewmodel.blockId,
                address: this.address,
            };
            checkoutService.saveInfo(this.viewmodel.apiUrl,
	            parameters,
	            (data) => { this.leadInformationSent = data.success, this.response = data.message },
                () => {  }
	        );
        },
        resetLookup() {
            this.$store.dispatch('resetAddressLookup');
        }
    },
    mounted: function () {

        document.addEventListener("keydown", (e) => {
            if (this.hasLookupFailure && e.keyCode === 27) {
                this.resetLookup();
            }
        });

        document.addEventListener('click', (e) => {

            e = e || window.event;
            var target = e.target || e.srcElement;
            if (this.hasLookupFailure && target.classList && target.classList.length > 0 && target.classList[0] === 'ts-modal') {
                this.resetLookup() 
            }
        }, false);

    }
}
